module.exports = __webpack_public_path__ + "img/icon_integralMall.a545218d.png";